import { render, staticRenderFns } from "./DiagnoseTable.vue?vue&type=template&id=119d174c&scoped=true&"
import script from "./DiagnoseTable.vue?vue&type=script&lang=tsx&"
export * from "./DiagnoseTable.vue?vue&type=script&lang=tsx&"
import style0 from "./DiagnoseTable.vue?vue&type=style&index=0&id=119d174c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119d174c",
  null
  
)

export default component.exports